import React, { Component } from "react";
import PropTypes from "prop-types";
import { inject, observer } from "mobx-react";
import {
  GridContainer,
  GridRow,
  GridColumn,
  Loader,
} from "arv-reactcomponents";
import ShippingView from "./ShippingView";
import PaymentView from "./PaymentView";
import CheckoutSubheader from "../../component/CheckoutSubheader";
import ContinueLogin from "../../component/ContinueLogin";
import { Checkout as CHECKOUT } from "npmlinks-constants";
import BreachHandler from "../../component/CheckoutComponents/BreachHandler";
import Analytics from "../../analytics";
import Event from "../../analytics/eventFactory";

@inject("LoginStore", "CheckoutStore", "PaymentStore")
@observer
class Checkout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
     };
    this.mounted = this.mounted.bind(this);
    this.validateLogin = this.validateLogin.bind(this);
    this.triggerTransactionFailureGA = this.triggerTransactionFailureGA.bind(
      this,
    );
  }
  componentDidMount() {
    this.validateLogin();
    this.mounted();
    this.triggerTransactionFailureGA();
  }
  componentDidUpdate() {
    this.validateLogin();
  }
  mounted() {
    this.setState({ loading: false });
  }

  triggerTransactionFailureGA() {
    if (this.currentView === "paymentfailure") {
      Analytics.trackEvent({
        action: Event.action.TRANSACTION_FAILURE,
        category: Event.category.CHECKOUT,
      });
    }
  }

  validateLogin() {
    const { isUserLoggedIn } = this.props.LoginStore;
    if (!isUserLoggedIn) {
      this.props.LoginStore.setloginModal(true, true);
    }
  }
  get currentView() {
    const { pathname } = this.props.location;
    if (!Object.values(CHECKOUT.CHECKOUT_ROUTES.SUPPORTED).includes(pathname)) {
      this.props.history.replace(CHECKOUT.CHECKOUT_ROUTES.DEFAULT, {});
      return "shipping";
    }
    const [currentView] = Object.keys(
      CHECKOUT.CHECKOUT_ROUTES.SUPPORTED,
    ).filter(item => CHECKOUT.CHECKOUT_ROUTES.SUPPORTED[item] === pathname);
    return currentView;
  }
  get currentTemplate() {
    const { loading } = this.state;
    switch (this.currentView) {
      case "payment":
        return <PaymentView.component parentLoading={loading} />;
      case "paymentfailure":
        return <PaymentView.component parentLoading={loading} />;
      default:
        return <ShippingView.component parentLoading={loading} />;
    }
  }
  get loading() {
    return (
      this.props.CheckoutStore.loading ||
      this.props.PaymentStore.loading ||
      this.state.loading
    );
  }
  get failureTitle() {
    return (
      (this.currentView === "paymentfailure" && (
        <div className="nw-checkoutpage-failure">
          <h3 className="nw-checkoutpage-failuretitle">
            {CHECKOUT.CHECKOUT_MESSAGES.PAYMENT_FAILURE.TITLE}
          </h3>
          <div className="nw-checkoutpage-failurecontent">
            {CHECKOUT.CHECKOUT_MESSAGES.PAYMENT_FAILURE.MESSAGE}
          </div>
        </div>
      )) ||
      null
    );
  }

  render() {
    const { isUserLoggedIn } = this.props.LoginStore;
    if (!isUserLoggedIn && !this.loading) {
      return (
        <GridContainer>
          <GridRow>
            <GridColumn className="nw-checkoutpage-nonloggedincontainer">
              {(!isUserLoggedIn && (
                <ContinueLogin.component altMsg="checkout" />
              )) ||
                null}
            </GridColumn>
          </GridRow>
        </GridContainer>
      );
    }

    return (
      <div>
        {this.loading && (
          <div className="nw-checkoutpage-initialloader nwc-translucentbackground-white">
            <Loader />
          </div>
        )}
        <CheckoutSubheader.component currentView={this.currentView} />
        <div className="nw-checkoutpage-container">
          {this.failureTitle}
          <BreachHandler.component />
          {this.currentTemplate}
        </div>
      </div>
    );
  }
}

Checkout.wrappedComponent.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired,
  }).isRequired,
  LoginStore: PropTypes.shape({
    isUserLoggedIn: PropTypes.bool.isRequired,
    setloginModal: PropTypes.func.isRequired,
  }).isRequired,
  CheckoutStore: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
  }).isRequired,
  PaymentStore: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
  }).isRequired,
};

export { default as PaymentView } from "./PaymentView";
export { default as ShippingView } from "./ShippingView";

const getFinalComponent = component =>
  inject("LoginStore", "CheckoutStore", "PaymentStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: Checkout.wrappedComponent,
  component: Checkout,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/pages/Checkout/index.js